const items = [
  "Sienite della Balma",
  "GMB Graniti s.r.l.",
  "Estrazione 1840 — oggi",
  "Sienite Verde",
  "Picapere · Tradizione",
  "Campiglia Cervo · Biella",
];

export default function Marquee() {
  const loop = [...items, ...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-[var(--border-subtle)] bg-[var(--surface-1)] overflow-hidden py-5"
    >
      <div className="flex w-max marquee-track gap-12 whitespace-nowrap">
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-display text-2xl md:text-3xl text-neutral-300 flex items-center gap-12"
          >
            {t}
            <span className="block w-2 h-2 rotate-45 bg-[var(--accent)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
